// extracted by mini-css-extract-plugin
export default {"showIcon":"FilterHeader_showIcon__E1vNc"};